export const exploreData = {
  'Cooked Meals': {
    title: 'South Indian & North Indian Delights',
    description: 'Authentic homestyle cooking delivered fresh to your doorstep',
    items: [
      {
        name: 'South Indian Thali',
        description:
          'Complete meal with sambar, rasam, rice, chapati, and 4 curries',
        price: 149,
        originalPrice: 199,
        rating: 4.8,
        time: '25-30 min',
        isVeg: true,
        badge: 'Bestseller',
        image:
          'https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?auto=format&fit=crop&w=600&q=80',
      },
      {
        name: 'Masala Dosa',
        description:
          'Crispy dosa with spiced potato filling, served with sambar and chutney',
        price: 89,
        rating: 4.7,
        time: '20-25 min',
        isVeg: true,
        image:
          'https://images.unsplash.com/photo-1630294277837-b33ec1b0b46e?auto=format&fit=crop&w=600&q=80',
      },
      {
        name: 'Butter Chicken Combo',
        description: 'Creamy butter chicken with basmati rice and naan bread',
        price: 199,
        originalPrice: 249,
        rating: 4.9,
        time: '35-40 min',
        badge: 'Popular',
        image:
          'https://images.unsplash.com/photo-1603894584373-5ac82b2ae398?auto=format&fit=crop&w=600&q=80',
      },
      {
        name: 'Chole Bhature',
        description: 'Spicy chickpea curry with fluffy bhature bread',
        price: 129,
        rating: 4.6,
        time: '25-30 min',
        isVeg: true,
        image:
          'https://images.unsplash.com/photo-1606491956689-2ea866880c84?auto=format&fit=crop&w=600&q=80',
      },
      {
        name: 'Hyderabadi Biryani',
        description:
          'Aromatic basmati rice with tender mutton and traditional spices',
        price: 249,
        rating: 4.8,
        time: '40-45 min',
        badge: 'Chef Special',
        image:
          'https://images.unsplash.com/photo-1563379091339-03246963d25a?auto=format&fit=crop&w=600&q=80',
      },
      {
        name: 'Idli Vada Combo',
        description:
          'Soft idlis and crispy vadas with sambar and coconut chutney',
        price: 79,
        rating: 4.5,
        time: '15-20 min',
        isVeg: true,
        image:
          'https://images.unsplash.com/photo-1589301760014-d929f3979dbc?auto=format&fit=crop&w=600&q=80',
      },
    ],
  },

  'Fresh Vegetables': {
    title: 'Farm-Fresh Daily Vegetables',
    description:
      'Hand-picked, pesticide-free vegetables sourced directly from farms',
    items: [
      {
        name: 'Mixed Vegetable Box',
        description:
          'Fresh seasonal vegetables - tomatoes, onions, potatoes, carrots (2kg)',
        price: 159,
        originalPrice: 199,
        time: '2-4 hours',
        isVeg: true,
        badge: 'Farm Fresh',
        image:
          'https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=600&q=80',
      },
      {
        name: 'Organic Green Leafy Box',
        description:
          'Spinach, methi, coriander, mint leaves - pesticide free (1kg)',
        price: 89,
        time: '2-4 hours',
        isVeg: true,
        badge: 'Organic',
        image:
          'https://images.unsplash.com/photo-1540420773420-3366772f4999?auto=format&fit=crop&w=600&q=80',
      },
      {
        name: 'Premium Tomatoes',
        description:
          'Fresh, juicy tomatoes perfect for cooking and salads (1kg)',
        price: 45,
        originalPrice: 60,
        time: '2-4 hours',
        isVeg: true,
        image:
          'https://images.unsplash.com/photo-1592841200221-a6898f307baa?auto=format&fit=crop&w=600&q=80',
      },
      {
        name: 'English Cucumber',
        description: 'Crisp and fresh cucumbers, perfect for salads (500g)',
        price: 35,
        time: '2-4 hours',
        isVeg: true,
        image:
          'https://images.unsplash.com/photo-1449300079323-02e209d9d3a6?auto=format&fit=crop&w=600&q=80',
      },
      {
        name: 'Bell Pepper Mix',
        description: 'Colorful bell peppers - red, yellow, green (500g)',
        price: 89,
        time: '2-4 hours',
        isVeg: true,
        badge: 'Colorful',
        image:
          'https://images.unsplash.com/photo-1563565375-f3fdfdbefa83?auto=format&fit=crop&w=600&q=80',
      },
      {
        name: 'Fresh Herbs Bundle',
        description: 'Basil, oregano, thyme, and rosemary for cooking',
        price: 79,
        time: '2-4 hours',
        isVeg: true,
        image:
          'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=600&q=80',
      },
    ],
  },

  'Beverages & Add‑ons': {
    title: 'Refreshing Drinks & Perfect Add-ons',
    description: 'Fresh juices, traditional beverages, and complementary items',
    items: [
      {
        name: 'Fresh Orange Juice',
        description: 'Freshly squeezed orange juice, no added sugar (300ml)',
        price: 69,
        rating: 4.6,
        time: '10-15 min',
        isVeg: true,
        badge: 'Fresh',
        image:
          'https://images.unsplash.com/photo-1600271886742-f049cd451bba?auto=format&fit=crop&w=600&q=80',
      },
      {
        name: 'Masala Buttermilk',
        description:
          'Traditional spiced buttermilk with mint and coriander (250ml)',
        price: 39,
        rating: 4.5,
        time: '5-10 min',
        isVeg: true,
        image:
          'https://images.unsplash.com/photo-1623065422902-30a2d299bbe4?auto=format&fit=crop&w=600&q=80',
      },
      {
        name: 'Filter Coffee',
        description:
          'Authentic South Indian filter coffee, strong and aromatic',
        price: 49,
        rating: 4.8,
        time: '5-10 min',
        isVeg: true,
        badge: 'Authentic',
        image:
          'https://images.unsplash.com/photo-1559056199-641a0ac8b55e?auto=format&fit=crop&w=600&q=80',
      },
      {
        name: 'Mango Lassi',
        description:
          'Creamy mango lassi made with fresh mangoes and yogurt (300ml)',
        price: 79,
        rating: 4.7,
        time: '10-15 min',
        isVeg: true,
        image:
          'https://images.unsplash.com/photo-1544145945-f90425340c7e?auto=format&fit=crop&w=600&q=80',
      },
      {
        name: 'Coconut Chutney',
        description:
          'Fresh coconut chutney with ginger and green chilies (100g)',
        price: 29,
        rating: 4.4,
        time: '5-10 min',
        isVeg: true,
        image:
          'https://images.unsplash.com/photo-1606491956689-2ea866880c84?auto=format&fit=crop&w=600&q=80',
      },
      {
        name: 'Mixed Fruit Juice',
        description:
          'Healthy blend of seasonal fruits, no artificial flavors (350ml)',
        price: 89,
        originalPrice: 109,
        rating: 4.6,
        time: '15-20 min',
        isVeg: true,
        badge: 'Healthy',
        image:
          'https://images.unsplash.com/photo-1546548970-71785318a17b?auto=format&fit=crop&w=600&q=80',
      },
    ],
  },

  'Custom Combos': {
    title: 'Tailored Meal Solutions',
    description: 'Perfect combinations for individuals, families, and offices',
    items: [
      {
        name: 'Solo Diner Special',
        description: 'Mini thali with rice, dal, sabzi, chapati, and pickle',
        price: 99,
        originalPrice: 129,
        rating: 4.5,
        time: '20-25 min',
        isVeg: true,
        badge: 'Value Pack',
        image:
          'https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?auto=format&fit=crop&w=600&q=80',
      },
      {
        name: 'Family Feast (4 People)',
        description:
          'Complete meal for 4 with variety of dishes, rice, and breads',
        price: 499,
        originalPrice: 649,
        rating: 4.8,
        time: '35-40 min',
        badge: 'Family Pack',
        image:
          'https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=600&q=80',
      },
      {
        name: 'Office Lunch Box',
        description: 'Healthy office meal with protein, carbs, and vegetables',
        price: 149,
        rating: 4.6,
        time: '25-30 min',
        isVeg: true,
        badge: 'Office Special',
        image:
          'https://images.unsplash.com/photo-1562059390-a761a084768e?auto=format&fit=crop&w=600&q=80',
      },
      {
        name: 'Party Platter (10 People)',
        description: 'Assorted snacks and meals perfect for small gatherings',
        price: 1199,
        originalPrice: 1499,
        rating: 4.7,
        time: '45-60 min',
        badge: 'Party Pack',
        image:
          'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?auto=format&fit=crop&w=600&q=80',
      },
      {
        name: 'Healthy Bowl',
        description: 'Quinoa, grilled vegetables, protein, and house dressing',
        price: 179,
        rating: 4.5,
        time: '20-25 min',
        isVeg: true,
        badge: 'Healthy',
        image:
          'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&w=600&q=80',
      },
      {
        name: 'Breakfast Combo',
        description: 'Poha, idli, and coffee - perfect morning start',
        price: 89,
        rating: 4.4,
        time: '15-20 min',
        isVeg: true,
        image:
          'https://images.unsplash.com/photo-1589301760014-d929f3979dbc?auto=format&fit=crop&w=600&q=80',
      },
    ],
  },
};
